import { Form } from "react-bootstrap";
import styled from "styled-components";

const StyledFormCheck = styled(Form.Check)`
    font-weight: 500;
    font-size: 17px;
    color: #787878;
    border-color: #787878;
    .form-check-input {
        border: 2px solid #787878;
        background: transparent;
        &:checked {
            background-color: #9654ff;
            border-color: #9654ff;
        }
        &:focus {
            box-shadow: none !important;
        }
    }
`;

export default { StyledFormCheck };
